import { Link } from 'react-router-dom'
import CoordinatorCourseSectionRow from './CoordinatorCourseSectionRow'
import DisplayNumberOfSections from '../common/DisplayNumberOfSections'
import AddSectionButton from '../common/AddSectionButton'
import { getCountSum } from '../../../utils/common'
import { numberFormat } from '../../../utils/numbers'
import { COURSE_FILTER, COURSE_TYPE_FILTER } from '../../../constants/FilterConstants'

import stylesheet from '../../../assets/style/scss/courses-table.scss'
import { getFilters } from '../../../actions/filters'

const mapStateToProps = (state, ownProps) => {
  const { course, isCourseView, showExamDecisions, courseSections } = ownProps
  const filters = getFilters(window.location.search) || {}

  return {
    course,
    isCourseView,
    showExamDecisions,
    courseSections,
    courseIsFiltered: Object.keys(filters).find(f => f !== COURSE_TYPE_FILTER.filter)?.length, // Basically, we don't want to auto-expand if the only filter selected is Course Type
  }
}

class CoordinatorCourseRow extends Component {
  constructor(props) {
    super(props)
    this.state = { sectionsVisible: false }
  }

  componentDidMount() {
    const { courseIsFiltered } = this.props

    if (courseIsFiltered) {
      this.setState({ sectionsVisible: true })
    }
  }

  componentDidUpdate(prevProps) {
    const { courseSections, courseIsFiltered } = this.props

    // If a section was just added to a course, expand the course
    if (courseSections.length > prevProps.courseSections.length && !this.state.sectionsVisible) {
      this.setState({ sectionsVisible: true })
    }
    // Expand the course's sections when initially turning a course filter on
    if (!prevProps.courseIsFiltered && courseIsFiltered && !this.state.sectionsVisible) {
      this.setState({ sectionsVisible: true })
    }
  }

  render() {
    const {
      course: { testCd, courseName },
      courseSections,
      isCourseView,
      showExamDecisions = true,
    } = this.props
    const { sectionsVisible } = this.state
    const numSections = courseSections.length
    const totalSectionEnrollments = getCountSum(courseSections, 'maxNumberOfStudents')
    const courseEnrollmentCount = getCountSum(courseSections, 'enrollmentCount')
    const examCount = getCountSum(courseSections, 'examCount')
    const showSections = (sectionsVisible && numSections > 1) || numSections === 1
    const rowSpan = showSections && numSections > 0 ? numSections + 1 : 1

    if (!isCourseView && !numSections) {
      return null
    }

    return (
      <tbody>
        {isCourseView ? (
          <tr className={stylesheet['course-row']}>
            <th className={stylesheet['course-name']} rowSpan={rowSpan} scope="rowgroup">
              <Link to={`/students?${COURSE_FILTER.filter}=${testCd}`}>{courseName}</Link>
            </th>
            <td className={stylesheet['section-count']}>
              <DisplayNumberOfSections
                courseId={testCd}
                numSections={numSections}
                sectionsVisible={showSections}
                toggleVisibility={() => this.setState({ sectionsVisible: !sectionsVisible })}
              />
              <div>
                <AddSectionButton testCd={testCd} styles={{ margin: '0' }} />
              </div>
            </td>
            <td className={stylesheet.teachers}></td>
            <td className={stylesheet.enrollments}>
              {numberFormat(courseEnrollmentCount)}/{numberFormat(totalSectionEnrollments)}
            </td>
            <td className={stylesheet['exam-decision']}>
              {showExamDecisions
                ? `${numberFormat(examCount)}/${numberFormat(courseEnrollmentCount)}`
                : null}
            </td>
            {/*<td className={stylesheet.payment}>0/0</td>*/}
            <td className={stylesheet.actions}>
              <span style={{ width: '70px' }} />
              {/*<div className="dropdown cb-dropdown">
                <a className="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-expanded={false} aria-haspopup={true}>
                  <span>Actions</span>
                  <span className="sr-only">Press Enter for Dropdown.</span>
                  <i className="cb-glyph cb-glyph-right cb-down" aria-hidden="true"></i>
                  <i className="cb-glyph cb-glyph-right cb-up hidden" aria-hidden="true"></i>
                </a>
              </div>*/}
            </td>
          </tr>
        ) : null}

        {showSections || !isCourseView
          ? courseSections.map((section, index) => (
              <CoordinatorCourseSectionRow
                key={index}
                section={section}
                isSectionView={!isCourseView}
                showExamDecisions={showExamDecisions}
              />
            ))
          : null}
      </tbody>
    )
  }
}

export default connect(mapStateToProps)(CoordinatorCourseRow)
